import React, { Component, Fragment } from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

import * as actions from 'store/modules/content';
import Content from 'scenes/Content';
import Styles from 'scenes/Styles';
import Analytics from 'scenes/Analytics';
import { HeaderLoggedIn } from 'scenes/Header';

import Footer from 'scenes/Footer';

const DashboardNavigation = props => {
  return (
    <div className="nav-tabs">
      <div className="wrapper">
        <div className="nav-tabs__inner">
          <NavLink exact to="/domain/page/content" className="nav-tabs__link">
            Content
          </NavLink>
          <NavLink exact to="/domain/page/styles" className="nav-tabs__link">
            Styles
          </NavLink>
          {props.subscribed ? (
            <NavLink exact to="/dashboard/analytics" className="nav-tabs__link">
              Analytics
            </NavLink>
          ) : null}
        </div>
      </div>
    </div>
  );
};

class Dashboard extends Component {
  componentDidMount() {
    this.props.showAccountAction();
  }

  render() {
    const { subscribed } = this.props.details;
    return (
      <Fragment>
        <HeaderLoggedIn />
        <DashboardNavigation subscribed={subscribed} />
        <Switch>
          <Route exact path="/dashboard/" component={Content} />
          <Route exact path="/dashboard/styles" component={Styles} />
          {subscribed ? (
            <Route exact path="/dashboard/analytics" component={Analytics} />
          ) : null}
        </Switch>
        <Footer />
      </Fragment>
    );
  }
}
function mapStateProps(state) {
  return {
    token: state.auth.token,
    details: state.details.user,
  };
}
export default connect(
  mapStateProps,
  actions,
)(Dashboard);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/index.js